import { useState, useEffect } from 'react';
import './MailchimpSignupForm.css';

const MailchimpSignupForm = ({ setHasSubmitted }) => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState(null); // null | 'success' | 'error' | 'exists'

  // Simple email validation
  const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  useEffect(() => {
    if (status === 'success' || status === 'exists') {
      localStorage.setItem('emailCaptured', 'true');
      setHasSubmitted(true);
    }
  }, [status]);

  const FUNCTION_URL = 'https://us-central1-i-mak-patent-database.cloudfunctions.net/subscribe';
  // const FUNCTION_URL = 'http://localhost:8080/subscribe'; // Local testing

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(FUNCTION_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email,
          tags: ['drug-patent-book-2025']
        }),
      });

      let data = null;
      const contentType = response.headers.get('content-type');

      if (contentType && contentType.includes('application/json')) {
        data = await response.json();
      } else {
        data = await response.text(); // fallback for plain text errors
      }

      if (response.ok) {
        setStatus('success');
        setEmail('');
      } else if (data?.title === 'Member Exists') {
        setStatus('exists');
      } else {
        setStatus('error');
        console.error('Server responded with:', data);
      }
    } catch (err) {
      console.error('Network or parsing error:', err);
      setStatus('error');
    }
  };

  return (
    <div className="mc-form">
      {status === 'success' ? (
        <div className="success-message">
          <p>You're subscribed</p>
        </div>
      ) : (
        <>
          <h3>Join us to access the data</h3>
          <p className="signup-disclaimer">By registering for the Drug Patent Book, you agree to receive our monthly newsletter. You may opt out of the newsletter at any time without affecting your access to the Drug Patent Book's services.</p>
          <form onSubmit={handleSubmit}>
            <input
              type="email"
              value={email}
              placeholder="Enter your email"
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <button
              type="submit"
              className="signup-button"
              disabled={!isValidEmail}
            >
              Join
            </button>
          </form>
          {status === 'exists' && <p className="text-exists">You’re already subscribed.</p>}
          {status === 'error' && <p className="text-error">Something went wrong. Try again later.</p>}
        </>
      )}
    </div >
  );
};

export { MailchimpSignupForm };